import { z } from 'zod';

export const CalculationResponseSchema = z.object({
    id: z.number().nullable(),
    day: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable(),
    type: z.string().nullable(),
});
export type CalculationResponseType = z.infer<typeof CalculationResponseSchema>;

export const CalculationResultResponseSchema = z.object({
    id: z.number().nullable(),
    calculation_id: z.number().nullable(),
    connection_id: z.number().nullable(),
    route_type_id: z.number().nullable(),
    date_created: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable(),
    route_length: z.number().nullable().describe('meters'),
    etoll_price: z.number().nullable(),
    au_cat1: z.number().nullable(),
    au_cat2: z.number().nullable(),
    au_cat3: z.number().nullable(),
    au_cat4: z.number().nullable(),
    country_roads_length: z.number().nullable().describe('meters'),
    express_roads_length: z.number().nullable().describe('meters'),
    highway_roads_length: z.number().nullable().describe('meters'),
    country_roads_time: z.number().nullable().describe('minutes'),
    express_roads_time: z.number().nullable().describe('minutes'),
    highway_roads_time: z.number().nullable().describe('minutes'),
    total_time: z.number().nullable().describe('minutes'),
});
export type CalculationResultResponseType = z.infer<typeof CalculationResultResponseSchema>;

export const ConnectionRequestSchema = z.object({
    location_id_from: z.number().nullable(),
    location_id_to: z.number().nullable(),
    is_ad_hoc: z.boolean(),
    note: z.string().catch(''),
});
export type ConnectionRequestType = z.infer<typeof ConnectionRequestSchema>;

export const ConnectionResponseSchema = ConnectionRequestSchema.merge(
    z.object({
        id: z.number(),
    })
);
export type ConnectionResponseType = z.infer<typeof ConnectionResponseSchema>;

export const JobCountSchema = z.object({
    count: z.coerce.number().catch(0),
});
export type JobCountType = z.infer<typeof JobCountSchema>;
